var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (partner) {
buf.push("<div id=\"partner-contact\"><div class=\"partner-contact-info\">");
if ( partner.has('website'))
{
buf.push("<div class=\"contact-website\"><a" + (jade.attr("href", partner.get('website'), true, true)) + " target=\"_blank\" class=\"partner-website\">" + (jade.escape(null == (jade_interp = partner.getSimpleWebsite()) ? "" : jade_interp)) + "</a></div>");
}
buf.push("</div><div class=\"partner-locations\"><div class=\"loading-spinner\"></div></div><div class=\"partner-vat-info\"></div></div>");}.call(this,"partner" in locals_for_with?locals_for_with.partner:typeof partner!=="undefined"?partner:undefined));;return buf.join("");
};
module.exports = template;